import { render, staticRenderFns } from "./PatientEncounterHistory.vue?vue&type=template&id=54987f92&scoped=true"
import script from "./PatientEncounterHistory.vue?vue&type=script&lang=js"
export * from "./PatientEncounterHistory.vue?vue&type=script&lang=js"
import style0 from "./PatientEncounterHistory.scss?vue&type=style&index=0&id=54987f92&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54987f92",
  null
  
)

export default component.exports